<div class="modal-header">
  <h4 class="modal-title">Vote {{proposal.approved ? ' - APPROVED' : proposal.declined ? ' - DECLINED' : ''}}</h4>
</div>
@if (proposal) {
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-9">
        <dx-form [formData]="proposal">
          <dxi-item dataField="created" [label]="{ text: 'Date' }" [disabled]="true"></dxi-item>
          <dxi-item [label]="{ text: 'Description' }">
            <div *dxTemplate>
              <dx-text-area [value]="proposal.description" [height]="150" [readOnly]="true"> </dx-text-area>
            </div>
          </dxi-item>
          <dxi-item [label]="{ text: 'Notes' }">
            <div *dxTemplate>
              <dx-text-area [value]="proposal.notes" [height]="150" [readOnly]="true"> </dx-text-area>
            </div>
          </dxi-item>
          <dxi-item dataField="fromCommittee" [editorOptions]="{ readOnly: true }"></dxi-item>
          <dxi-item dataField="toCommittee" [editorOptions]="{ readOnly: true }"></dxi-item>
          <!-- <dxi-item [label]="{ text: 'Vote' }">
          <div *dxTemplate>
            <dx-radio-group [(value)]="voteValue" [items]="values" [layout]="'horizontal'" [readOnly]="readOnly" > </dx-radio-group>
          </div>
        </dxi-item>
        <dxi-item [label]="{ text: 'User' }">
          <div *dxTemplate>
            <dx-text-box [value]="auth.currentUser.userName" [readOnly]="true"> </dx-text-box>
          </div>
        </dxi-item> -->
      </dx-form>
    </div>
    <div class="col-sm-3">
      <div style="font-weight: bold; text-decoration: underline;" >VOTE INFORMATION</div>
      <div>Yes: {{yesVotes}}</div>
      <div>No: {{noVotes}}</div>
      @if (proposal.proposalVotes.length > 10) {
        <div >Yes %: {{yesPercentage}}</div>
      }
      @if (proposal.proposalVotes.length > 10) {
        <div>No %: {{noPercentage}}</div>
      }
    </div>
  </div>
</div>
}
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">Save</button>
  <button type="button" class="btn btn-light" (click)="close()">Cancel</button>
</div>
